import { initAnalytics, StateAnalyticsParams } from './analytics/analytics';
import { initRealUserMonitoring } from './realUserMonitoring/realUserMonitoring';
import { updateGdprApplies } from './init.utils';
import { markPerformance } from './performance/index';
import { ErrorReporter } from './errorReporter.type';

export type CoreParams = StateAnalyticsParams;

const monitoringEndpoint = 'https://rum.minutemediaservices.com/';

export function init(params: CoreParams, errorProvider: ErrorReporter) {
  const { pageType, countryCode } = params;

  initRealUserMonitoring(countryCode, pageType, monitoringEndpoint, errorProvider);

  try {
    initAnalytics(params);
    markPerformance('init-analytics');
  } catch (e) {
    errorProvider.reportException(e);
  }
  try {
    updateGdprApplies();
  } catch (e) {
    errorProvider.reportException(e);
  }
}
